import request from '@/utils/request'

// 厂家/二手货源列表
export function getsupplyList(data) {
    return request({
        url: '/equipment/product/selectProduct',
        method: 'post',
        data
    })
}

//租凭货源列表
export function getrentList(data) {
    return request({
        url: '/equipment/lease/list',
        method: 'post',
        data
    })
}
//获取省市区
export function getCitylist(data) {
    return request({
        url: '/common/api/getCity',
        method: 'post',
        data
    })
}
//商品分类
export function getCategory(data) {
    return request({
        url: '/equipment/productCategory/indexCategory',
        method: 'post',
        data
    })
}
// ====
//商品分类s
export function getCategorys(data) {
    return request({
        url: '/equipment/product/getCategory',
        method: 'post',
        data
    })
}
